<template>
  <div>
    <div>
      <div>
        <el-row>
          <div class="left-justifying"><h3>客户合同</h3></div>
          <div class="right-justifying">
            <el-button type="info" plain size="small" @click="toAdd" v-if="addBtnExisted">
              <i class="fa fa-plus-circle"></i> 新建
            </el-button>
            <el-button type="info" plain size="small" @click="saveAdd" v-if="saveAddBtnExisted">
              <i class="fa fa-save"></i> 保存
            </el-button>
            <el-button type="info" plain size="small" @click="toEdit" v-if="editBtnExisted" :disabled="!editBtnEnabled">
              <i class="fa fa-pencil"></i> 修改
            </el-button>
            <el-button type="info" plain size="small" @click="saveEdit" v-if="saveEditBtnExisted">
              <i class="fa fa-save"></i> 保存
            </el-button>
            <el-button type="info" plain size="small" @click="cancelEdit" v-if="cancelEditBtnExisted">
              <i class="fa fa-undo"></i> 取消
            </el-button>
            <el-button type="info" plain size="small" @click="toRemove" v-if="deleteBtnExisted" :disabled="!deleteBtnEnabled">
              <i class="fa fa-times"></i> 删除
            </el-button>
            <WorkflowRequestBtn v-if="workflowBtnExisted" :visible="workflowBtnExisted" :use-new-api="true"
                                :bussiness="'CONTRACT'"
                                :bussinessId="detail.data.id"
                                :bussinessInfo="workflowBussinessInfo"
                                :disabled="false"
                                :is-can-send="isCanSendWorkflow"
                                @afterRequestWorkflowFunc="afterRequestWorkflowFunc"
            >
            </WorkflowRequestBtn>
            <WorkflowReopenBtn v-if="workflowReopenBtnExisted" :visible="workflowReopenBtnExisted" :use-new-api="true"
                               :bussiness="'CONTRACT'"
                               :bussinessId="detail.data.id"
                               :bussinessInfo="workflowBussinessInfo"
                               :disabled="false"
                               @afterRequestWorkflowFunc="afterRequestWorkflowFunc"
                               :button-text="'变更'"
            >
            </WorkflowReopenBtn>
            <WorkflowDialog v-if="detail.data != null" ref="workflowDialog"
                            :bussiness="'CONTRACT'"
                            :bussinessId="detail.data.id"
                            :workflowRequestInfo="workflowRequestInfo"
                            :dialogWorkflowVisible.sync="workflowDialogVisible"
                            :status-name="'CONTRACTSTATUS'"
                            @afterAuditWorkflowFunc="afterAuditWorkflowFunc">

            </WorkflowDialog>
          </div>
        </el-row>
      </div>
      <div class="panel">
        <div class="panel-body">
          <el-row>
            <div class="advanced-search-location">
              <el-checkbox v-if="activeTabName === 'list'" v-model="list.search.eq_flag" :true-label="'0'" :false-label="''" size="mini">非阿里合同</el-checkbox>
              <el-tag v-if="activeTabName !== 'list' && detail.data != null && detail.data.flag === 0 && detail.data.workflowStatus != null" type="danger" size="mini" style="margin-top: 9px;">
                状态：<dictionary-text :factory-name="'domain'" :params="'BCWSTATUS'" :value="detail.data.workflowStatus"></dictionary-text>
              </el-tag>
            </div>
            <el-tabs v-model="activeTabName" :before-leave="beforeLeave">
              <el-tab-pane label="列表" name="list">
                <contract-list ref="list" :search="list.search"></contract-list>
              </el-tab-pane>
              <el-tab-pane label="详情" name="detail">
                <contract-detail ref="detail" :operation="operation" :id="detail.data != null ? detail.data.id : -1"
                  @afterLoadWorkflowHistory="afterLoadWorkflowHistory">
                </contract-detail>
              </el-tab-pane>
            </el-tabs>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  COMPONENT_MAIN,
  FN_LIST_QUERY,
  FN_SET_OPERATION,
  FN_SET_TAB,
  FN_TO_DETAIL_SHOW,
  OPERATION_DETAIL_ADD,
  OPERATION_DETAIL_EDIT,
  OPERATION_DETAIL_SHOW,
  OPERATION_LIST_DEFAULT,
  PERMISSION_ADD,
  PERMISSION_DELETE,
  PERMISSION_EDIT,
  TAB_DETAIL,
  TAB_LIST,
  contractIsEditable, contractIsDeletable,
} from "./contract.common";
  import DictionaryText from "@/components/common/DictionaryText";
  import WorkflowRequestBtn from '@/components/workflow/workflowRequestBtn'
  import WorkflowReopenBtn from '@/components/workflow/workflowReopenBtn'
  import WorkflowDialog from '@/components/workflow/workflowDialog'
  import ContractList from './contract.list'
  import ContractDetail from './contract.detail'

  import BillingServer from  '@/api/billing'
  import PersonUserServer from  '@/api/person/user'

  export default {
    name: COMPONENT_MAIN,
    componentName: COMPONENT_MAIN,
    components: {DictionaryText, WorkflowRequestBtn, WorkflowReopenBtn, WorkflowDialog, ContractList, ContractDetail},
    data() {
      return {
        activeTabName: TAB_LIST,
        operation: null,
        list: {
          search: {
            eq_flag: null,
          },
        },
        detail: {
          data: null,
        },
        roles: [],
        workflowDialogVisible: false,
        workflowRequestInfo: {},
      };
    },
    computed: {
      addBtnExisted() {
        return this.activeTabName === TAB_LIST && (PERMISSION_ADD == null || this.hasPermission(PERMISSION_ADD));
      },
      saveAddBtnExisted() {
        return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_ADD &&
                (PERMISSION_ADD == null || this.hasPermission(PERMISSION_ADD));
      },
      editBtnExisted() {
        return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW &&
                (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
      },
      saveEditBtnExisted() {
        return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_EDIT &&
                (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
      },
      cancelEditBtnExisted() {
        return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_EDIT &&
                (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
      },
      deleteBtnExisted() {
        return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW &&
            (PERMISSION_DELETE == null || this.hasPermission(PERMISSION_DELETE));
      },
      editBtnEnabled() {
        return this.editBtnExisted && contractIsEditable(this.detail.data);
      },
      deleteBtnEnabled() {
        return this.deleteBtnExisted && contractIsDeletable(this.detail.data) &&
            (this.workflowNodeLogs == null || this.workflowNodeLogs.length === 0);
      },
      workflowBtnExisted() {
        return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW && this.detail.data != null &&
            this.detail.data.flag === 0 && !this.workflowReopenBtnExisted;
      },
      workflowReopenBtnExisted() {
        return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW &&
            this.detail.data != null && this.detail.data.flag === 0 && this.detail.data.workflowStatus === 'CONFIRMED';
      },
      workflowBussinessInfo() {
        let bussinessInfo = {};
        bussinessInfo.params = JSON.stringify({
          CONTRACTSTATUS: this.detail.data.workflowStatus,
          roles: this.roles
        });
        return bussinessInfo;
      },
    },
    watch: {
      '$route': {
        deep: true,
        immediate: true,
        handler() {
          let query = this.$route.query;
          let id = query.id;
          if (id != null) {
            this.$nextTick(() => {
              this.look(id);
            });
          }
        },
      },
    },
    methods: {
      async getRoleUsers() {
        const { data } =await PersonUserServer.getRoleUsers()
        let roles = []
        if(data.data.length > 0) {
          data.data.map(r => {
            if(r.role && r.role.rolename) {
              roles.push(r.role.rolename)
            }
          })
          this.roles = roles
        }
      },
      setDefaultOperation(tabName) {
        if (this.operation == null || this.operation.split('.')[0] !== tabName) {
          let operation;
          if (tabName === TAB_LIST) {
            operation = OPERATION_LIST_DEFAULT;
            this[FN_LIST_QUERY]();
          } else if (tabName === TAB_DETAIL) {
            operation = OPERATION_DETAIL_SHOW;
            this.detail.data = this.$refs['list'].currentRowData;
          }
          if (operation != null) {
            this[FN_SET_OPERATION](operation);
          }
        }
      },
      beforeLeave(tabName, oldTabName) {
        if (oldTabName === TAB_DETAIL && (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT)) {
          return this.$confirm('您输入的数据未保存，确认离开吗？', '离开提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let detail = this.$refs['detail'];
            if (detail != null) {
              detail.reset();
            }
            this.setDefaultOperation(tabName);
            return Promise.resolve();
          }, () => {
            return Promise.reject();
          });
        } else {
          this.setDefaultOperation(tabName);
        }
        return Promise.resolve();
      },
      [FN_SET_TAB](tabName) {
        this.activeTabName = tabName;
      },
      [FN_SET_OPERATION](operation) {
        this.operation = operation;
      },
      [FN_TO_DETAIL_SHOW](data) {
        this[FN_SET_TAB](TAB_DETAIL);
        this[FN_SET_OPERATION](OPERATION_DETAIL_SHOW);
        this.doLook(data.id);
      },
      look(id) {
        this[FN_SET_TAB](TAB_DETAIL);
        this[FN_SET_OPERATION](OPERATION_DETAIL_SHOW);
        this.doLook(id);
      },
      doLook(id) {
        this.workflowNodeLogs = null;
        this.$refs['detail'].look(id);
      },
      setDetailData(data) {
        this.detail.data = data;
      },
      [FN_LIST_QUERY]() {
        this.$refs['list'].query();
      },
      toAdd() {
        this[FN_SET_TAB](TAB_DETAIL);
        this[FN_SET_OPERATION](OPERATION_DETAIL_ADD);
        this.$refs['detail'].toAdd();
      },
      saveAdd() {
        this.$refs['detail'].saveAdd();
      },
      toEdit() {
        this[FN_SET_TAB](TAB_DETAIL);
        this[FN_SET_OPERATION](OPERATION_DETAIL_EDIT);
      },
      saveEdit() {
        this.$refs['detail'].saveEdit();
      },
      cancelEdit() {
        this.$refs['detail'].cancelEdit();
      },
      toRemove() {
        this.$refs['detail'].toRemove();
      },
      afterLoadWorkflowHistory(workflowNodeLogs) {
        this.workflowNodeLogs = workflowNodeLogs;
      },
      async isCanSendWorkflow() {
        let canSend = false;
        if (this.$refs.detail != null) {
          canSend = await this.$refs.detail.isCanSendWorkflow();
        }
        return canSend;
      },
      async isCanAudit() {
        let canSend = false;
        if (this.$refs.detail != null) {
          canSend = await this.$refs.detail.isCanAudit();
        }
        return canSend;
      },
      afterRequestWorkflowFunc(a) {
        this.workflowDialogVisible = true;
        this.workflowRequestInfo = a;
      },
      async afterAuditWorkflowFunc(businessInfo) {
        let setValue = businessInfo.setValue == null ? null : JSON.parse(businessInfo.setValue);
        let op = setValue == null ? null : setValue.OP;
        let canAudit;
        if (op !== 'CANCEL') {
          canAudit = await this.isCanAudit();
        } else {
          canAudit = true;
        }
        if (canAudit) {
          let response;
          try {
            response = await BillingServer.contract.workflowAudit(businessInfo, {loading: true});
          } catch (error) {
            let message = error.message;
            if (error.response != null && error.response.data != null && error.response.data.message != null) {
              message = error.response.data.message;
            } else if (error.response != null && error.response.data != null && error.response.data.responseMessage != null) {
              message = error.response.data.responseMessage;
            }
            this.$message.error(message);
          }
          if (response != null) {
            if (String(response.data.code) === '200' || response.data.success) {
              this.$refs.workflowDialog.close();
              this.workflowDialogVisible = false;
              this.$message.success('工作流发送成功！');
              this.doLook(this.detail.data.id);
            } else {
              this.$message.error(response.data.responseMessage);
            }
          }
        }
      },
    },
    created() {
      this.$on(FN_SET_TAB, (data) => {
        this[FN_SET_TAB](data);
      });
      this.$on(FN_SET_OPERATION, (data) => {
        this[FN_SET_OPERATION](data);
      });
      this.$on(FN_TO_DETAIL_SHOW, (data) => {
        this[FN_TO_DETAIL_SHOW](data);
      });
      this.$on('setDetailData', (data) => {
        this.setDetailData(data);
      });
      this.getRoleUsers()
    },
    mounted() {
      setTimeout(() => {
        this[FN_LIST_QUERY]();
      });
    }
  }
</script>

<style scoped>

</style>
